module.exports = __webpack_public_path__ + "static/media/placeholder.bac728e3.jpg";